const TreeUtils = {
  flattenTree: (treeNodes: TreeNode[]): TreeNode[] => {
    const flatNodes: TreeNode[] = [];
    const traverse = (nodes: TreeNode[]) => {
      for (const node of nodes) {
        flatNodes.push(node);
        if (node.children) {
          traverse(node.children);
        }
      }
    };
    traverse(treeNodes);
    return flatNodes;
  },

  findNodeById: (treeNodes: TreeNode[], id: string) =>
    treeNodes.find((node) => node.id.localeCompare(id) === 0),

  finNodeInTree: (treeNodes: TreeNode[], id: string): TreeNode | null => {
    for (const node of treeNodes) {
      if (node.id.localeCompare(id) === 0) {
        return node;
      }
      if (node.children) {
        const foundNode = TreeUtils.finNodeInTree(node.children, id);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    return null;
  },
};

export default TreeUtils;
